import { useState, useEffect } from 'react';

const TABLET_BREAKPOINT = 1024;

export const useBreakpoint = () => {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= TABLET_BREAKPOINT,
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT}px)`);
    const handler = (e) => setIsMobile(e.matches);

    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return { isMobile };
};
